import script from "./houseBottom.vue?vue&type=script&setup=true&lang=js"
export * from "./houseBottom.vue?vue&type=script&setup=true&lang=js"

import "./houseBottom.vue?vue&type=style&index=0&id=5a98ea8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a98ea8a"]])

export default __exports__